import React from "react";

export default function AWS_RDS() {
  return (
    <div>
      <h1>What is AWS RDS</h1>
      <p>
        Route: <code>/aws/rds</code>
      </p>
      <p>Auto-generated component.</p>
    </div>
  );
}
